<template>
  <div>
    <TextBlob headingSize="m">
      <template #heading> Forgotten Password </template>
      <template #text>
        <div class="flex w-full justify-center">
          <div class="w-[90%] md:w-1/3">
            <el-input v-model="email" ref="bizReviewLink" placeholder="" style="width: 100%"
              @keydown.enter.prevent="forgotLogin">
              <template #prepend>
                <span class="font-bold w-[110px] text-right">Email</span>
              </template>
            </el-input>
          </div>
        </div>
        <br />
        <div class="w-2/3 flex flex-col mx-auto">
          <div class="flex justify-center">
            <el-button class="mt-4 md:w-1/3" type="primary" size="large" plain @click="forgotLogin">Send Password Reset
              Email</el-button>
          </div>
          <div class="flex justify-center">
            <el-button class="mt-8 md:w-1/3" type="primary" size="large" plain
              @click="userStore.activeRoute = 'login'">Back
              to
              Login</el-button>
          </div>
        </div>
        <div v-if="sent" class="text-lg">
          {{ sent }}
        </div>
        <LoginError :error="errorMessage" />
      </template>
    </TextBlob>
  </div>
</template>
<script setup>
import { ref } from "vue";
import { getAuth, sendPasswordResetEmail } from "firebase/auth";
import LoginError from "./LoginError.vue";
import TextBlob from "@/components/TextBlob.vue";
import { useError } from "@/composables/useError";
const { errorMessage, processError } = useError();

import { useUser } from '@/stores';
const userStore = useUser()
const email = ref("")
const sent = ref("")

const forgotLogin = () => {
  const auth = getAuth();
  sendPasswordResetEmail(auth, email.value)
    .then(() => {
      // console.log("Password reset email sent!")
      sent.value = "Password reset email sent"
    })
    .catch((error) => {
      processError(error);
      // console.log("error", error)
    });
}

</script>
<style scoped></style>